















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzsxMoniResultShijuangailan extends Vue {
  @Prop()
  private result;
  @Prop()
  private exam;
  @Prop()
  private leftTime;
  private get user() {
    return this.$store.state.user;
  }
  private jump(index) {
    this.$emit("jump", index);
  }
}
